// extracted by mini-css-extract-plugin
module.exports = {"aside":"sidebar_aside__cGWTX","button":"sidebar_button__2PGhT","slideRight":"sidebar_slideRight__y02_g","slideLeft":"sidebar_slideLeft__6vZrh"};